
const MotivationalQuoteSection = () => {
  return (
    <div className="text-center mb-6 p-6 bg-white/50 rounded-2xl border border-soft-blue/30">
      <p className="text-lg text-deep-blue/80 font-medium mb-2">
        "The secret to getting ahead is getting started."
      </p>
      <p className="text-deep-blue/70">
        Show up again tomorrow! 💙
      </p>
    </div>
  );
};

export default MotivationalQuoteSection;
